import { create } from 'zustand'

const useStore = create((set, get) => {
  const getters = {}

  return {
    locale: 'zh',
    domainRedFlag: false,
    auth: '',
    setDomainRedFlag: () =>
      set((state: any) => ({
        ...state,
        domainRedFlag: !state.domainRedFlag,
      })),
    quoteInfo: {},
    setQuoteInfo: (info: any) =>
      set((state: any) => ({
        ...state,
        quoteInfo: info,
      })),
    setStore: (obj: unknown) => set(obj),
    ...getters,
  }
})

export default useStore
